var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 352,
    viewBox: "0 0 352 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 352,
    fill: "#1EAFD2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.818 168.454H112C107.582 168.454 104 172.036 104 176.454V272.454C104 276.873 107.582 280.454 112 280.454H240C244.418 280.454 248 276.873 248 272.454V176.454C248 172.036 244.418 168.454 240 168.454H202.182",
    stroke: "white",
    strokeWidth: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.657 65.3433C178.533 62.2191 173.467 62.2191 170.343 65.3433L119.431 116.255C116.307 119.379 116.307 124.444 119.431 127.569C122.556 130.693 127.621 130.693 130.745 127.569L176 82.3138L221.255 127.569C224.379 130.693 229.444 130.693 232.569 127.569C235.693 124.444 235.693 119.379 232.569 116.255L181.657 65.3433ZM184 200.522L184 71.0001L168 71.0001L168 200.522L184 200.522Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare2);
export default __webpack_public_path__ + "static/media/share2.0799ce2f93b50fad4d6df734c4cc68c9.svg";
export { ForwardRef as ReactComponent };